// solution Routes
import {
  // routeParams,
  moduleDetailsPath,
  // buildAppRoutePath,
  buildModuleDetailsRouteName,
  buildModuleRouteName,
  buildModuleRoutePath
} from "@/router/solution/solutionRoutes";

// services
import { applicationName as application } from "@/services/solution/solutionService";
import {
  routeName as employeeAccessRoute,
  modulePageTitle as employeeAccessPageTitle
} from "@/services/employeeAccess/employeeAccessService";

// router
import { buildAppRouteName } from "@/router/solution/solutionRoutes";

/**
 * Get Employee Access Module Route Name
 * @param {String|string} moduleRouteName
 * @returns {String|string}
 */
const moduleRouteName = moduleRouteName =>
  buildModuleRouteName(application.EmployeeAccess, moduleRouteName);
/**
 * Get Employee Access Module Details Route Name
 * @param {String|string} moduleRouteName
 * @returns {string}
 */
const moduleDetailsRouteName = moduleRouteName => {
  return buildModuleDetailsRouteName(
    application.EmployeeAccess,
    moduleRouteName
  );
};

const employeeAccessRoutes = [
  {
    path: "",
    name: buildAppRouteName(application.EmployeeAccess),
    component: () => import("@/views/employeeAccess/home/EmployeeAccessHome"),
    meta: { requiresAuth: true },
    children: [
      {
        path: buildModuleRoutePath(employeeAccessRoute.Dashboard),
        name: moduleRouteName(employeeAccessRoute.Dashboard),
        meta: { requiresAuth: true, title: employeeAccessPageTitle.Dashboard },
        props: true,
        component: () =>
          import("@/views/employeeAccess/dashboard/DashboardContent")
      },
      {
        path: buildModuleRoutePath(employeeAccessRoute.Time),
        name: moduleRouteName(employeeAccessRoute.Time),
        meta: { requiresAuth: true, title: employeeAccessPageTitle.Time },
        props: true,
        component: () => import("@/views/employeeAccess/myTime/MyTimeContent")
      },
      {
        path: buildModuleRoutePath(employeeAccessRoute.Profile),
        name: moduleRouteName(employeeAccessRoute.Profile),
        meta: { requiresAuth: true, title: employeeAccessPageTitle.Profile },
        props: true,
        component: () =>
          import("@/views/employeeAccess/myProfile/MyProfileContent")
      },
      {
        path: buildModuleRoutePath(employeeAccessRoute.TimeOff),
        name: moduleRouteName(employeeAccessRoute.TimeOff),
        meta: { requiresAuth: true, title: employeeAccessPageTitle.TimeOff },
        props: true,
        component: () =>
          import("@/views/employeeAccess/myTimeOff/TimeOffContent")
      },
      {
        path: buildModuleRoutePath(employeeAccessRoute.Tasks),
        name: moduleRouteName(employeeAccessRoute.Tasks),
        meta: { requiresAuth: true, title: employeeAccessPageTitle.Tasks },
        props: true,
        component: () =>
          import("@/views/employeeAccess/myTasks/MyTasksContent"),
        children: [
          {
            path: moduleDetailsPath,
            name: moduleDetailsRouteName(employeeAccessRoute.Tasks),
            meta: {
              requiresAuth: true,
              title: employeeAccessPageTitle.TaskDetail
            },
            props: true,
            component: () =>
              import("@/views/employeeAccess/myTasks/MyTasksDetails")
          }
        ]
      },
      {
        path: buildModuleRoutePath(employeeAccessRoute.Requests),
        name: moduleRouteName(employeeAccessRoute.Requests),
        meta: { requiresAuth: true, title: employeeAccessPageTitle.Requests },
        props: true,
        component: () =>
          import("@/views/employeeAccess/myRequests/MyRequestsContent")
      }
    ]
  }
];

export { employeeAccessRoutes, moduleRouteName };
